import { render, staticRenderFns } from "./dettaglio.vue?vue&type=template&id=45ac3a34"
import script from "./dettaglio.vue?vue&type=script&lang=js"
export * from "./dettaglio.vue?vue&type=script&lang=js"
import style0 from "./dettaglio.vue?vue&type=style&index=0&id=45ac3a34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports